import { computed } from "aaa";
import externalInterfaceStore from "stores/ExternalInterfaceStore";

export class AppStoreRedirectStoreDeprecated {

    @computed get iosStoreUrl(): string {
        const url = "https://apps.apple.com/at/app/george-%C3%B6sterreich/id947829367";

        return externalInterfaceStore.isGeorgeApp ?
            `georgeapp://at/open_external_link?url=${encodeURIComponent(url)}` :
            url;
    }

    @computed get androidStoreUrl(): string {
        const url = "https://play.google.com/store/apps/details?id=at.erstebank.george";

        return externalInterfaceStore.isGeorgeApp ?
            `georgeapp://at/open_external_link?url=${encodeURIComponent(url)}` :
            url;
    }

    @computed get appGalleryStoreUrl(): string {
        const url = "https://appgallery.huawei.com/app/C102556323";

        return externalInterfaceStore.isGeorgeApp ?
            `georgeapp://at/open_external_link?url=${encodeURIComponent(url)}` :
            url;
    }
}



// WEBPACK FOOTER //
// ./src/components/appStoreRedirectDeprecated/AppStoreRedirectStoreDeprecated.ts